import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { useToggleableFormat } from '../hooks/useToggleableFormat';
import { FormatType } from '../types';

type FormattingContextState = {
  toggleBold: () => void;
  toggleItalic: () => void;
  toggleUnderline: () => void;
  isBoldEnabled: boolean;
  isItalicEnabled: boolean;
  isUnderlineEnabled: boolean;
};

export const defaultState: FormattingContextState = {
  toggleBold: () => null,
  toggleItalic: () => null,
  toggleUnderline: () => null,
  isBoldEnabled: false,
  isItalicEnabled: false,
  isUnderlineEnabled: false,
};

const FormattingContext = createContext(defaultState);

export const FormattingContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { isFormatEnabled: isBoldEnabled, toggleFormat: toggleBold } = useToggleableFormat(
    FormatType.bold,
  );
  const { isFormatEnabled: isItalicEnabled, toggleFormat: toggleItalic } = useToggleableFormat(
    FormatType.italic,
  );
  const { isFormatEnabled: isUnderlineEnabled, toggleFormat: toggleUnderline } =
    useToggleableFormat(FormatType.underline);

  return (
    <FormattingContext.Provider
      value={{
        toggleBold,
        toggleItalic,
        toggleUnderline,
        isBoldEnabled,
        isItalicEnabled,
        isUnderlineEnabled,
      }}
    >
      {children}
    </FormattingContext.Provider>
  );
};

export const useFormattingContext = () => useContext(FormattingContext);
